import { registerApplier } from '@/app/libs/I';
import { Store } from '@/app/modules/store/Store';
import { storeService } from '@/app/modules/store/StoreService';
import {
  storeGetter,
  storeSetter,
} from '@/app/modules/store/storeEffects';
import { useStore } from '@/shared/composition/useStore';

const buildKey = (model: Store) => {
  let commitKey = model.actionDetail;
  if (model.section) {
    commitKey = model.section + '/' + commitKey;
  }

  return commitKey;
};

registerApplier(storeService.applierId, (model: Store) => {
  const store = useStore();

  if (model.action === 'commit') {
    storeSetter({
      path: buildKey(model),
      value: model.payload,
    });
  }

  if (model.action === 'getters') {
    return storeGetter({
      path: buildKey(model),
      value: null,
    });
  }

  if (model.action === 'actions') {
    return storeSetter({
      path: buildKey(model),
      value: model.payload,
    });
  }

  return store;
});
